<template>
    <v-layout column>
        <v-flex v-if="hasPlans" xs12>
            <div class="app-choose-plan-v2">
                <app-membership-offer :loading="loading" @select="submit(`${$event.id}`)"></app-membership-offer>

                <div class="_plan-divider"><span>or</span></div>

                <div class="_plan-free">
                    <p class="_plan-free--title">Not ready to join today?</p>
                    <p class="_plan-free--text">Create a Free Account to browse NannyGrannies in your area.</p>
                    <p class="_plan-free--subtitle">Free accounts are browse-only.</p>
                    <p class="_plan-free--note">To contact, shortlist or connect with a NannyGranny, <br>you'll need to upgrade to a NannyGranny Membership.</p>
                    <v-btn :loading="loading"
                           outline
                           class="ma-0 elevation-0 _plan-free--btn"
                           @click="submitfree">
                        Continue with free account
                    </v-btn>
                </div>
            </div>
        </v-flex>
    </v-layout>
</template>

<script>
import { DEFAULT_SIGNUP_OPT,MAIN_SIGNUP_PLANS_OPT } from '../../config/constants'
import AppMembershipOffer from '../app-membership/app-membership-offer'
  export default {
    name: 'app-btn-toggle-plan-reg',
    components: {AppMembershipOffer},
    filters: {
      savePer: function (item) {
        return (100 - parseInt(parseFloat(item.price_all) * 100 / parseFloat(item.price)))
      }
    },

    props: {
      value: Number,
      showvalidplans: null,
      mandatory: {
        type: Number,
        default: 1
      },
      hideDescription: Boolean
    },

    data () {
        
      return {
        select: null,
        default_signup_method: DEFAULT_SIGNUP_OPT,
        //show_signup_method: showvalidplans,
      }
    },

    computed: {

      loading () {
        return this.$store.getters['register/loading']
      },

      hasPlans () {
        return this.$store.getters['subscription/hasPlans']
      },
     
      plans () {
        let plans= this.$store.getters['subscription/plans']
        if (typeof this.showvalidplans !== 'undefined') {
           
          const matchedElements = plans.filter(item1 => {
            return this.showvalidplans.find(item2 => item2 === item1.id);
          });
          return matchedElements
        }
        else{
            const matchedElements = plans.filter(item1 => {
            return this.default_signup_method.find(item2 => item2 === item1.id);
            });
            return matchedElements
        }

        
      }
    },

    watch: {
    
      select () {
       
        this.$store.commit('subscription/SET_PLAN', this.select)
        if (this.select) {
          this.$emit('input', this.select.id)
        }
      },
      currentPlan (plan) {
        let price = this.$lodash.get(plan, 'price_all', 0)
        this.form.summ = price ? price : this.$lodash.get(plan, 'price', 0)
      }
    },

    mounted () {
        
      if (this.hasPlans) {
        this.select = this.plans[this.mandatory]
      }
    },

    methods: {
        
      isSave: function (item) {
        return parseInt(item.price) !== parseInt(item.price_all) && !isNaN(item.price_all) && parseInt(item.price_all) > 0
      },
      submit (plan_id) {
        let plans =  this.$store.getters['subscription/plans']
        console.log(plans);
        var i;
        plans.forEach(function(x, index) {
            if (x.id == plan_id) {
                i = index;
            }
        });
        this.$store.commit('subscription/SET_PLAN', plans[i])
         this.$store.dispatch('register/STEP_2', {data: this.user})
          .then(() => (this.$router.push('/signup/step-3/parent')))
          .catch(error => (console.log(error)))
      },
      submitfree () {
        this.$router.push('/signup/step-3/parent-free')
      }
    }
  }
</script>

<style lang="stylus" scoped>
    .app-choose-plan-v2
        max-width 460px
        margin 20px auto
        p
            margin 0
    ._plan-divider
        display flex
        align-items center
        margin 24px 0
        color var(--charcoal)
        font-size 13px
        text-transform uppercase
        &:before, &:after
            content ''
            flex 1
            border-top 1px solid #ddd
        span
            padding 0 14px
    ._plan-free
        padding 0 12px
        &--title
            font-size 18px
            font-weight bold
            margin-bottom 6px !important
        &--text
            font-size 14px
        &--subtitle
            font-size 14px
            font-weight bold
            margin-top 12px !important
        &--note
            font-size 13px
            color var(--charcoal)
            margin-bottom 18px !important
        &--btn
            height auto !important
            padding 10px 20px !important
            color #000 !important
            font-weight bold
    @media (max-width: 480px)
        ._plan-free--note br
            display none
</style>



// WEBPACK FOOTER //
// src/components/app-buttons/app-btn-toggle-plan-reg.vue